export const BACKEND_URL: string = "https://structure-earnings-news.com/api";
